@if (show) {
<div class="modal-overlay" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>
        <span>{{ isEdit ? ('BRANDING.EDIT_TITLE' | translate) : ('BRANDING.CREATE_TITLE' | translate) }}</span>
      </h3>
      <button class="close-btn" (click)="onClose()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>

    <div class="modal-body">
      <form (ngSubmit)="onSave()">
        <div class="form-group">
          <label>{{ 'BRANDING.FORM.SLUG' | translate }}</label>
          <input type="text" [(ngModel)]="form.slug" name="slug" [disabled]="isEdit"
            [placeholder]="'BRANDING.FORM.SLUG_PLACEHOLDER' | translate">
          <span class="field-hint">{{ 'BRANDING.FORM.SLUG_HINT' | translate }}</span>
        </div>

        <div class="form-group">
          <label>{{ 'BRANDING.FORM.NAME' | translate }}</label>
          <input type="text" [(ngModel)]="form.name" name="name" required>
        </div>

        <div class="form-checkbox">
          <input type="checkbox" [(ngModel)]="form.is_active" name="is_active" id="tenant-is-active">
          <label for="tenant-is-active">{{ 'BRANDING.FORM.IS_ACTIVE' | translate }}</label>
        </div>

        <div class="colors-row">
          <div class="form-group color-field">
            <label>{{ 'BRANDING.FORM.ACCENT_LIGHT' | translate }}</label>
            <div class="color-input-wrapper">
              <input type="color" [(ngModel)]="colors.accentColor" name="accentLight"
                (ngModelChange)="onAccentChange(false)">
              <input type="text" class="hex-input" [(ngModel)]="colors.accentColor" name="accentLightHex"
                (blur)="onAccentChange(false)" maxlength="7" placeholder="#FF009A">
            </div>
          </div>

          <div class="form-group color-field">
            <label>{{ 'BRANDING.FORM.ACCENT_DARK' | translate }}</label>
            <div class="color-input-wrapper">
              <input type="color" [(ngModel)]="darkColors.accentColor" name="accentDark"
                (ngModelChange)="onAccentChange(true)">
              <input type="text" class="hex-input" [(ngModel)]="darkColors.accentColor" name="accentDarkHex"
                (blur)="onAccentChange(true)" maxlength="7" placeholder="#FF009A">
            </div>
          </div>
        </div>

        <div class="theme-preview-row">
          <div class="theme-preview">
            <span class="theme-preview-title">{{ 'BRANDING.FORM.THEME_LIGHT' | translate }}</span>
            <div class="theme-preview-box light">
              <div class="preview-menu-item"
                [style.background]="colors.bgSelected"
                [style.border-left-color]="colors.accentColor">
                {{ 'BRANDING.FORM.PREVIEW_MENU_ITEM' | translate }}
              </div>
              <button type="button" class="preview-button"
                [style.background]="colors.buttonBg"
                [style.border-color]="colors.buttonBorder"
                [style.color]="colors.accentColor">
                {{ 'BRANDING.FORM.PREVIEW_BUTTON' | translate }}
              </button>
            </div>
          </div>

          <div class="theme-preview">
            <span class="theme-preview-title">{{ 'BRANDING.FORM.THEME_DARK' | translate }}</span>
            <div class="theme-preview-box dark">
              <div class="preview-menu-item"
                [style.background]="darkColors.bgSelected"
                [style.border-left-color]="darkColors.accentColor">
                {{ 'BRANDING.FORM.PREVIEW_MENU_ITEM' | translate }}
              </div>
              <button type="button" class="preview-button"
                [style.background]="darkColors.buttonBg"
                [style.border-color]="darkColors.buttonBorder"
                [style.color]="darkColors.accentColor">
                {{ 'BRANDING.FORM.PREVIEW_BUTTON' | translate }}
              </button>
            </div>
          </div>
        </div>

        <button type="button" class="advanced-toggle" (click)="toggleAdvancedMode()">
          <fa-icon [icon]="advancedMode ? faChevronUp : faChevronDown"></fa-icon>
          <span>{{ 'BRANDING.FORM.ADVANCED' | translate }}</span>
        </button>

        @if (advancedMode) {
        <div class="advanced-section">
          <p class="advanced-hint">{{ 'BRANDING.FORM.ADVANCED_HINT' | translate }}</p>

          <div class="advanced-theme">
            <span class="advanced-theme-title">{{ 'BRANDING.FORM.THEME_LIGHT' | translate }}</span>

            <div class="form-group">
              <label>{{ 'BRANDING.FORM.TONE_BG_SELECTED' | translate }}</label>
              <div class="tone-input-row">
                <input type="color" [ngModel]="toneHex(colors.bgSelected)" name="bgSelectedLightColor"
                  (ngModelChange)="updateToneColor(colors, 'bgSelected', $event)">
                <input type="range" min="0" max="100" [ngModel]="toneAlphaPercent(colors.bgSelected)"
                  name="bgSelectedLightAlpha" (ngModelChange)="updateToneAlpha(colors, 'bgSelected', $event)">
                <span class="tone-alpha-value">{{ toneAlphaPercent(colors.bgSelected) }}%</span>
              </div>
            </div>

            <div class="form-group">
              <label>{{ 'BRANDING.FORM.TONE_BUTTON_BG' | translate }}</label>
              <div class="tone-input-row">
                <input type="color" [ngModel]="toneHex(colors.buttonBg)" name="buttonBgLightColor"
                  (ngModelChange)="updateToneColor(colors, 'buttonBg', $event)">
                <input type="range" min="0" max="100" [ngModel]="toneAlphaPercent(colors.buttonBg)"
                  name="buttonBgLightAlpha" (ngModelChange)="updateToneAlpha(colors, 'buttonBg', $event)">
                <span class="tone-alpha-value">{{ toneAlphaPercent(colors.buttonBg) }}%</span>
              </div>
            </div>

            <div class="form-group">
              <label>{{ 'BRANDING.FORM.TONE_BUTTON_HOVER_BG' | translate }}</label>
              <div class="tone-input-row">
                <input type="color" [ngModel]="toneHex(colors.buttonHoverBg)" name="buttonHoverBgLightColor"
                  (ngModelChange)="updateToneColor(colors, 'buttonHoverBg', $event)">
                <input type="range" min="0" max="100" [ngModel]="toneAlphaPercent(colors.buttonHoverBg)"
                  name="buttonHoverBgLightAlpha" (ngModelChange)="updateToneAlpha(colors, 'buttonHoverBg', $event)">
                <span class="tone-alpha-value">{{ toneAlphaPercent(colors.buttonHoverBg) }}%</span>
              </div>
            </div>

            <div class="form-group">
              <label>{{ 'BRANDING.FORM.TONE_BUTTON_BORDER' | translate }}</label>
              <div class="tone-input-row">
                <input type="color" [ngModel]="toneHex(colors.buttonBorder)" name="buttonBorderLightColor"
                  (ngModelChange)="updateToneColor(colors, 'buttonBorder', $event)">
                <input type="range" min="0" max="100" [ngModel]="toneAlphaPercent(colors.buttonBorder)"
                  name="buttonBorderLightAlpha" (ngModelChange)="updateToneAlpha(colors, 'buttonBorder', $event)">
                <span class="tone-alpha-value">{{ toneAlphaPercent(colors.buttonBorder) }}%</span>
              </div>
            </div>
          </div>

          <div class="advanced-theme">
            <span class="advanced-theme-title">{{ 'BRANDING.FORM.THEME_DARK' | translate }}</span>

            <div class="form-group">
              <label>{{ 'BRANDING.FORM.TONE_BG_SELECTED' | translate }}</label>
              <div class="tone-input-row">
                <input type="color" [ngModel]="toneHex(darkColors.bgSelected)" name="bgSelectedDarkColor"
                  (ngModelChange)="updateToneColor(darkColors, 'bgSelected', $event)">
                <input type="range" min="0" max="100" [ngModel]="toneAlphaPercent(darkColors.bgSelected)"
                  name="bgSelectedDarkAlpha" (ngModelChange)="updateToneAlpha(darkColors, 'bgSelected', $event)">
                <span class="tone-alpha-value">{{ toneAlphaPercent(darkColors.bgSelected) }}%</span>
              </div>
            </div>

            <div class="form-group">
              <label>{{ 'BRANDING.FORM.TONE_BUTTON_BG' | translate }}</label>
              <div class="tone-input-row">
                <input type="color" [ngModel]="toneHex(darkColors.buttonBg)" name="buttonBgDarkColor"
                  (ngModelChange)="updateToneColor(darkColors, 'buttonBg', $event)">
                <input type="range" min="0" max="100" [ngModel]="toneAlphaPercent(darkColors.buttonBg)"
                  name="buttonBgDarkAlpha" (ngModelChange)="updateToneAlpha(darkColors, 'buttonBg', $event)">
                <span class="tone-alpha-value">{{ toneAlphaPercent(darkColors.buttonBg) }}%</span>
              </div>
            </div>

            <div class="form-group">
              <label>{{ 'BRANDING.FORM.TONE_BUTTON_HOVER_BG' | translate }}</label>
              <div class="tone-input-row">
                <input type="color" [ngModel]="toneHex(darkColors.buttonHoverBg)" name="buttonHoverBgDarkColor"
                  (ngModelChange)="updateToneColor(darkColors, 'buttonHoverBg', $event)">
                <input type="range" min="0" max="100" [ngModel]="toneAlphaPercent(darkColors.buttonHoverBg)"
                  name="buttonHoverBgDarkAlpha" (ngModelChange)="updateToneAlpha(darkColors, 'buttonHoverBg', $event)">
                <span class="tone-alpha-value">{{ toneAlphaPercent(darkColors.buttonHoverBg) }}%</span>
              </div>
            </div>

            <div class="form-group">
              <label>{{ 'BRANDING.FORM.TONE_BUTTON_BORDER' | translate }}</label>
              <div class="tone-input-row">
                <input type="color" [ngModel]="toneHex(darkColors.buttonBorder)" name="buttonBorderDarkColor"
                  (ngModelChange)="updateToneColor(darkColors, 'buttonBorder', $event)">
                <input type="range" min="0" max="100" [ngModel]="toneAlphaPercent(darkColors.buttonBorder)"
                  name="buttonBorderDarkAlpha" (ngModelChange)="updateToneAlpha(darkColors, 'buttonBorder', $event)">
                <span class="tone-alpha-value">{{ toneAlphaPercent(darkColors.buttonBorder) }}%</span>
              </div>
            </div>
          </div>
        </div>
        }

        @if (isEdit) {
        <div class="logos-row">
          <div class="logo-field">
            <label>{{ 'BRANDING.FORM.LOGO_SMALL' | translate }}</label>
            @if (logoSmallPreview) {
            <img [src]="logoSmallPreview" class="logo-preview" alt="logo small" (error)="onLogoSmallError()">
            }
            <input #logoSmallInput type="file" accept=".png,.jpg,.jpeg,.svg" style="display:none"
              (change)="onLogoSmallSelected($event)">
            <button type="button" class="upload-btn" (click)="triggerLogoSmallInput()">
              <fa-icon [icon]="faUpload"></fa-icon>
              <span>{{ 'BRANDING.FORM.UPLOAD_LOGO' | translate }}</span>
            </button>
          </div>

          <div class="logo-field">
            <label>{{ 'BRANDING.FORM.LOGO_FULL' | translate }}</label>
            @if (logoFullPreview) {
            <img [src]="logoFullPreview" class="logo-preview" alt="logo full" (error)="onLogoFullError()">
            }
            <input #logoFullInput type="file" accept=".png,.jpg,.jpeg,.svg" style="display:none"
              (change)="onLogoFullSelected($event)">
            <button type="button" class="upload-btn" (click)="triggerLogoFullInput()">
              <fa-icon [icon]="faUpload"></fa-icon>
              <span>{{ 'BRANDING.FORM.UPLOAD_LOGO' | translate }}</span>
            </button>
          </div>
        </div>

        @if (suggestedColors.length > 0) {
        <div class="suggested-colors">
          <span class="suggested-colors-label">{{ 'BRANDING.FORM.SUGGESTED_COLORS' | translate }}</span>
          <div class="suggested-colors-row">
            @for (hex of suggestedColors; track hex) {
            <button type="button" class="color-suggestion" [style.background]="hex" [title]="hex"
              (click)="applySuggestedColor(hex)">
            </button>
            }
          </div>
        </div>
        }
        } @else {
        <p class="field-hint">{{ 'BRANDING.FORM.LOGO_AFTER_CREATE' | translate }}</p>
        }

        <div class="form-actions">
          <app-button [text]="'BUTTON.CANCEL' | translate" variant="secondary" (clicked)="onClose()">
          </app-button>
          <app-button [text]="isEdit ? ('BUTTON.SAVE' | translate) : ('BUTTON.CREATE' | translate)" variant="primary"
            [icon]="faCheck" [loading]="loading" [disabled]="loading" (clicked)="onSave()">
          </app-button>
        </div>
      </form>
    </div>
  </div>
</div>
}
